import { DeviceInfo } from '../../../api-http/devices';
import { DeviceInfoWrapper } from '../styles';
import { Grid, Typography } from '@mui/material';
import { FC } from 'react';

interface AdditionalInfoProps {
  deviceInfo?: DeviceInfo;
}

const deviceData = [
  'Resolution',
  'User Agent',
  'Brand',
  'Manufacturer',
  'Ip Address',
];
let infoKeys: string[];

export const camelCaseToWords = (str: string) => {
  // Split the string into an array of words
  const words = str.split(/(?=[A-Z])/);

  // Capitalize the first letter of each word and join them together
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const deviceInfoValue = (infoName: string, displayValue: any) => {
  if (infoName === 'touchEnable') {
    if (displayValue === true) return 'Yes';
    else return 'No';
  } else return displayValue;
};

const AdditionalInfo: FC<AdditionalInfoProps> = ({ deviceInfo }) => {
  if (deviceInfo) {
    // eslint-disable-next-line
    const { _id, ...rest } = deviceInfo;
    infoKeys = deviceInfo && Object.keys({ ...rest });
  } else {
    infoKeys = [...deviceData];
  }

  const additionalInfo = infoKeys?.map((infoName: string) => {
    const volumeFields = ['totalSpace', 'freeSpace'];
    const byteToGBConversion = 1000000000;
    let displayValue;

    if (deviceInfo) {
      if (volumeFields.includes(infoName)) {
        displayValue = `${(deviceInfo[infoName] / byteToGBConversion).toFixed(
          2,
        )} GB`;
      } else {
        displayValue = deviceInfo[infoName];
      }

      const freeSpacePercent = (
        (deviceInfo?.freeSpace / deviceInfo?.totalSpace) *
        100
      ).toFixed(2);

      return (
        <Grid item xs={12} sm={6} md={4} key={infoName}>
          <Typography
            sx={{
              mt: 2,
              color: '#64748b',
              fontSize: 12,
              fontWeight: 700,
            }}
          >
            {camelCaseToWords(infoName)}
          </Typography>
          <Typography
            sx={{
              mt: 0.5,
              color: '#0f172a',
              fontSize: 13,
              overflowWrap: 'anywhere',
            }}
          >
            {deviceInfoValue(infoName, displayValue)}
          </Typography>
          {infoName === 'freeSpace' ? (
            <meter value={freeSpacePercent} max="100">
              {freeSpacePercent}% free space
            </meter>
          ) : null}
        </Grid>
      );
    }
  });

  return (
    <DeviceInfoWrapper>
      <Grid container columnSpacing={3}>
        <Grid item xs={12}>
          <Typography
            component="h2"
            sx={{
              borderBottom: '1px solid #e2e8f0',
              pb: 1.5,
              color: '#0f172a',
              fontSize: 18,
              fontWeight: 700,
            }}
          >
            Device information
          </Typography>
        </Grid>
        {additionalInfo}
      </Grid>
    </DeviceInfoWrapper>
  );
};
export default AdditionalInfo;
